<template>
  <div>
    <template v-for="(item, i) in items">
      <div
        v-if="item.isAccordion && visibleMenuChildren(item.children).length"
        :key="i"
        :class="['menu_item', itemClass]"
      >
        <a class="menu_item_top ease" href="javascript:void(0)">
          {{ item.title }}
        </a>
        <div class="drop_bt" @click="dropMenu"><ArrowDownSvg /></div>
        <div :class="['drop_open', dropOpenClass]">
          <div
            v-for="child in visibleMenuChildren(item.children)"
            :key="child.path || child.action"
          >
            <a
              v-if="child.action"
              class="drop_link flex flex--start"
              href="javascript:void(0)"
              @click="runMenuAction(child.action, closeOnNavigate)"
            >
              <span v-if="child.icon" class="menu-drop-icon">
                <component :is="iconMap[child.icon]" />
              </span>
              {{ child.title }}
            </a>
            <a
              v-else-if="child.target"
              class="drop_link flex flex--start"
              :href="child.path"
              :target="child.target"
              @click="closeOnNavigate ? onTargetClick() : null"
            >
              <span v-if="child.icon" class="menu-drop-icon">
                <component :is="iconMap[child.icon]" />
              </span>
              {{ child.title }}
            </a>
            <a
              v-else
              class="drop_link flex flex--start"
              :class="{
                active:
                  showActive &&
                  ($route.path == child.path || $route.path == child.path + '/')
              }"
              :href="child.path"
              @click.prevent="onRoute(child.path, closeOnNavigate)"
            >
              <span v-if="child.icon" class="menu-drop-icon">
                <component :is="iconMap[child.icon]" />
              </span>
              {{ child.title }}
            </a>
          </div>
        </div>
      </div>

      <div
        v-else-if="isMenuItemVisible(item)"
        :key="item.path"
        :class="[
          'menu_item',
          itemClass,
          {
            active:
              showActive &&
              ($route.path == item.path || $route.path == item.path + '/')
          }
        ]"
        @click="item.target && closeOnNavigate ? onTargetClick() : null"
      >
        <a
          v-if="item.target"
          :href="item.path"
          :target="item.target"
          class="menu_item_top ease"
        >
          {{ item.title }}
        </a>
        <a
          v-else
          class="menu_item_top ease"
          :href="item.path"
          @click.prevent="onRoute(item.path, closeOnNavigate)"
        >
          {{ item.title }}
          <span v-if="matchesDocsType(item.path)">
            <Bell :class="bellClass" />
            <div v-if="hasUnwatchedDocs(item.type)" :class="dotClass"></div>
          </span>
        </a>
      </div>
    </template>
  </div>
</template>

<script>
import menuMixin, { menuComponents } from "../../mixins/menuMixin.js";
import PenWhiteSvg from "../../assets/img/svg/ic-pen-white.svg";
import { mapActions } from "vuex";

export default {
  name: "MenuItems",
  mixins: [menuMixin],
  components: { ...menuComponents, PenWhiteSvg },
  props: {
    items: { type: Array, required: true },
    closeOnNavigate: { type: Boolean, default: false },
    bellClass: { type: String, default: "pathology-bell" },
    dotClass: { type: String, default: "pathology-dot" },
    showActive: { type: Boolean, default: false },
    itemClass: { type: String, default: "" },
    dropOpenClass: { type: String, default: "" },
    iconMap: {
      type: Object,
      default: () => ({
        date: "DateSvg",
        list: "ListSvg",
        pen: "PenSvg",
        card: "CardSvg",
        lock: "LockSvg",
        upload: "UploadSvg",
        contact: "DocCalanderSvg"
      })
    }
  },
  methods: {
    ...mapActions(["CLOSE_MENU"]),
    onTargetClick() {
      if (typeof this.CLOSE_MENU === "function") {
        this.CLOSE_MENU();
      }
    }
  }
};
</script>
